import { cn } from "@/lib/utils.js";

/**
 * Reusable loading indicator component
 * @param {Object} props
 * @param {string} props.size - Size variant: "sm" | "md" | "lg"
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.text - Optional loading text
 */
export default function LoadingIndicator({
  size = "sm",
  className,
  text,
  showText = false,
}) {
  const sizeClasses = {
    sm: "h-3 w-3",
    md: "h-4 w-4",
    lg: "h-8 w-8",
  };

  return (
    <div className={cn("flex items-center gap-1", className)}>
      <div
        className={cn(
          "animate-spin rounded-full border-2 border-primary border-t-transparent",
          sizeClasses[size]
        )}
      />
      {(showText || text) && (
        <span className='text-xs text-muted-foreground'>{text || "Loading..."}</span>
      )}
    </div>
  );
}
